const InfoLabel = ({ label, data }) => {
  return (
    <div className="info-label container-column">
      <label>{label}</label>
      <div className="label-data">{data}</div>
    </div>
  );
};

export default InfoLabel;
